import React, { useState, useRef, useEffect, useCallback } from 'react';
import './searchBarHero.css';
import useFetchAllCompanies from '../../../../hooks/company/useFetchAllCompanies';
import { useNavigate } from 'react-router-dom';
import useDebounce from '../../../../hooks/debouncer/useDebounce';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/pro-solid-svg-icons';

const positions = [
  "Garzón", "Runner", "Chef", "Ayudante de Cocina", "Anfitrión", "Delivery", "Cajero", "Copero",
  "Barista", "Bartender", "Sommelier", "Maitre", "Jefe de salón", "Limpieza", "Chef Ejecutivo",
  "Sous Chef", "Jefe de Cocina", "Maestro de Cocina", "Maestro Pastelero", "Pastelero", "Panadero",
  "Repostero", "Charcutero", "Pizzero", "Itamae", "Sushiman", "Ayudante de Sushi", "Parrillero",
  "Cocinero Frío", "Cocinero Caliente", "Manipulador de Alimentos", "Encargado de Producción",
  "Operador de Cocina", "Operador de Planta", "Operador Multifuncional", "Encargado de Reservas",
  "Recepcionista de Restaurante", "Supervisor de Salón", "Personal de Banquetería", "Encargado de Bodega",
  "Repositor", "Personal de Mantenimiento", "Jefe de Local", "Administrador de Local", "Jefe de Sucursales",
  "Administrador de Restaurante", "Encargado de Compras", "Control de Calidad", "Catador de Vinos",
  "Coordinador de Banquetes", "Montajista", "Mixólogo"
];

const SearchBarHero = ({ onSelectResult }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isResultsVisible, setIsResultsVisible] = useState(false);
  const [filteredPositions, setFilteredPositions] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const navigate = useNavigate()
  const searchContainerRef = useRef(null);
  const inputRef = useRef(null);
  const debouncedSearchTerm = useDebounce(searchTerm, 300);  
  const { companies, isLoading: isCompaniesLoading, error: companiesError } = useFetchAllCompanies({
    searchTerm: debouncedSearchTerm,
    type:"home-search"
  });

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    const filtered = positions.filter(position => 
      position.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredPositions(filtered);
    setIsResultsVisible(!!value);
  };

  const combinedResults = [
    ...filteredPositions.map(position => ({ type: 'trabajo', name: position })),
    ...companies.map(company => ({ id: company.id, type: 'empresa', name: company.name}))
  ];

  const handleResultClick = (result) => {
    if (result.type === 'empresa') {
     navigate(`/empresas/${result.id}`)
    }

    if (result.type === 'trabajo') {
      navigate(`/trabajos?search=${result.name}`);
    }

    setIsResultsVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setIsResultsVisible(false);  
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="search-bar-hero__container" ref={searchContainerRef}>
      <h1>La receta perfecta para tu próximo trabajo</h1>
      <div className="search-bar-hero__filter-container">
        <div className='search-container'>
          {/* <FontAwesomeIcon icon={faSearch} /> */}
          <input
            type="text"
            placeholder="Busca trabajos o empresas..."
            value={searchTerm}
            onChange={handleInputChange}
            className="search-bar-hero__input"
            onFocus={() => setIsResultsVisible(!!searchTerm)}
            ref={inputRef}
          />
        </div>  
        <div className="search-bar-hero__results-container">   
          {isResultsVisible && combinedResults.length > 0 && (
            <ul className="search-bar-hero__results">
              {combinedResults.map((result, index) => (
                <li key={index} onClick={() => handleResultClick(result)} className="search-bar-hero__list-item">
                  <h3>{result.name}</h3>
                  <p>{result.type}</p> 
                </li>
              ))}
            </ul>
          )}
          {isResultsVisible && combinedResults.length === 0 && (
            <p>No results found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchBarHero;
